// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alert-info[data-v-ac11de7a]{margin-bottom:15px}", "",{"version":3,"sources":["webpack://./resources/assets/js/src/modules/fields/components/AIAgentFieldConfiguratorWrapper.vue"],"names":[],"mappings":"AACA,6BACC,kBAAD","sourcesContent":["\n.alert-info {\n\tmargin-bottom: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
